import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';
import Tooltip from 'flarum/common/components/Tooltip';

export default class TicketAssignee extends Component {
  view() {
    return <Tooltip text={this.attrs.data.user().displayName()}>{avatar(this.attrs.data.user())}</Tooltip>;
  }
}
